import React from 'react';
import ReactDOM from 'react-dom';
import EngagementViewer from './app/index';

export default {
    EngagementViewer,
    DisplayViewer: (imageURL, humanEvent) => { ReactDOM.render(<EngagementViewer imageURL={imageURL} humanEvent={humanEvent} />, document.getElementById('EngagementViewerRoot')); }
};
